module.exports = __webpack_public_path__ + "img/2-3.cf81032d.jpg";